module.exports = __webpack_public_path__ + "static/img/sj_banner_cp.20b4c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_banner_cp.png
// module id = mkQI
// module chunks = 1